










































































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { StopActivatingPopup } from '@/decorators/stopPopupActive';
import { GQL_createInvoiceInterestCharge } from '@/queries/__generated__/createInvoiceInterestCharge';
import gql from 'graphql-tag';

const CREATE_INVOICE_INTEREST_CHARGE = gql`
  mutation createInvoiceInterestCharge($invoiceId: ID!) {
    createInvoiceInterestCharge(input: { invoiceId: $invoiceId }) {
      invoiceInterestCharge {
        id
        fromDate
        toDate
        days
        principalAmount
        interestAmount
        collectionFeeAmount
        totalAmount
        interestInvoice {
          id
          number
          dueDate
        }
      }
    }
  },
`;

@Component
export default class InterestChargeForm extends Vue {
  // Kept loose on purpose: this is rendered both from the invoice page and
  // from a row of the unpaid invoice list, which query different shapes.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop({ required: true }) private invoice!: any;
  @Prop({ type: String, default: '' }) private label!: string;
  @Prop({ type: String, default: 'standard' }) private color!: string;

  private CREATE_INVOICE_INTEREST_CHARGE = CREATE_INVOICE_INTEREST_CHARGE;
  private showInterestChargeDialog = false;

  private get preview() {
    return this.invoice.interestChargePreview;
  }

  @StopActivatingPopup()
  private openInterestChargeDialog(): void {
    this.showInterestChargeDialog = true;
  }

  @Emit()
  private mutationDone(data: { data: GQL_createInvoiceInterestCharge }) {
    const charge = data.data.createInvoiceInterestCharge?.invoiceInterestCharge;
    if (!charge) return;

    this.showInterestChargeDialog = false;
    // Move the row on without a refetch: the charge closes the step, and the
    // preview is what said it was open.
    this.$set(this.invoice, 'invoiceInterestCharges', [ charge ]);
    this.$set(this.invoice, 'interestChargePreview', {
      ...this.preview,
      chargeable: false,
      blockedReason: 'already_charged',
    });
  }
}
